import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { TiDocument, TiTime } from "react-icons/ti";
import _ from "../../../i18n";
import { Tooltip } from "antd";
import {
  FaAngleDoubleDown,
  FaAngleDoubleUp,
  FaEuroSign,
  FaSync,
} from "react-icons/fa";
import { ArrowRightOutlined } from "@ant-design/icons";

const DraggableDialog = () => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Tooltip placement="bottom" title={_("usefulInfo")}>
        <TiDocument
          color="#29394d"
          size={20}
          onClick={() => setVisible(true)}
        />
      </Tooltip>
      <Dialog
        header={_("usefulInfo")}
        visible={visible}
        onHide={() => setVisible(false)}
        draggable
        resizable
        modal={false}
        dismissableMask={false}
        style={{ height: "60vh", width: 280, position: "realtive" }}
        className="financial-p-dialog"
      >
        <div className="dialog-content-1">
          <h4>{_("symbols")}</h4>
          <div>
            <div>
              <div className="icon" style={{ "--i-color": "#FFAC3A" }}>
                <FaSync size={14} />
              </div>
              <span>En cours de révision des forfaits</span>
            </div>

            <div>
              <div
                className="icon"
                style={{ "--i-color": "#de4848", "--i-bg": "#de484825" }}
              >
                <TiTime size={14} />
              </div>
              <span>Suspicion Horaire</span>
            </div>

            <div>
              <div
                className="icon"
                style={{ "--i-color": "#de4848", "--i-bg": "#de484825" }}
              >
                <FaEuroSign size={14} />
              </div>
              <span>Suspicion Economique</span>
            </div>

            <div>
              <div className="icon" style={{ "--i-color": "#02af8e" }}>
                <FaAngleDoubleUp size={14} />
              </div>
              ou
              <div className="icon" style={{ "--i-color": "#de4848" }}>
                <FaAngleDoubleUp size={14} />
              </div>
              <span>Elevé</span>
            </div>

            <div>
              <div className="icon" style={{ "--i-color": "#de4848" }}>
                <FaAngleDoubleDown size={14} />
              </div>
              ou
              <div className="icon" style={{ "--i-color": "#02af8e" }}>
                <FaAngleDoubleDown size={14} />
              </div>
              <span>Basse</span>
            </div>

            <div>
              <div className="icon line-through" style={{ "--i-color": "#29394d" }}>
                X
              </div>
              ou
              <div className="icon" style={{ "--i-color": "#18a0fb" }}>
                <ArrowRightOutlined style={{ fontSize: 14 }} />
              </div>
              <span>{_('adjustment')}</span>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default DraggableDialog;
